characterData